import { MultiselectItem } from '@cokitchen/cokitchen-components/dist/form/multiselect/types';
import { ENUM_BRAND_TYPE, ENUM_SEARCH_TYPE, ENUM_TIER_NAME } from './enum';
import { MultiselectOptionsType } from './types';
import moment from 'moment';
import { RolePermissionType } from './permissions-type';

export const ROUTE_PREFIX = {
  FOOD: '/food-base',
  SHOP: '/shop-base'
};

export const ROUTE_KEYS = {
  LOGIN: '/login',
  DASHBOARD: '',
  OVERVIEW: 'overview',
  MEALS: 'meals',
  KITCHEN_LIST: 'kitchens',
  DINE_IN_LIST: 'dine-ins',
  CREATE_COKITCHEN: 'create-cokitchen',
  COKITCHEN_DETAILS: 'cokitchen',
  POLYGON: 'polygon',
  CATEGORY_MEALS: `meals/:category_id`,
  CATEGORY_ITEMS: `items/:category_id`,
  POPUP_KITCHEN: 'popup-kitchen',
  FEEDS: '/feeds',
  SETTINGS: '/settings',
  MEAL_METADATA: 'metadata/meal',
  BRAND_METADATA: 'metadata/brand',
  ALLERGY_METADATA: 'metadata/allergy',
  DIETARY_METADATA: 'metadata/dietary',
  TRASH: '/trash',
  PRICING: 'pricing',
  MANAGE_BASE_MEALS: 'manage-base-meals',
  MEAL_BY_BASE_ADDON_CATEGORY: 'base-addon-category/meals-by-base-addon-cat/:id',
  SEARCH: 'search/:search_value/:type',
  NEW_ADDON_CATEGORY: 'meals/create-addon-category',
  NEW_MEAL_XLS: 'meals/new-meal-xls',
  NEW_MEAL: 'meals/new-meal',
  NEW_MEAL_CATEGORY: 'meals/new-meal-category',
  NEW_ADDON: 'meals/new-addon',

  // TODO :: further refactor
  CREATE_BRAND: 'create-brand',
  BRAND_DETAILS: 'brand/:brand_id',
  CAREER_DETAILS: '/career/:job_id',
  EDIT_MULTIPLE_BRANDS: 'brand/edit-multiple-brands',
  EDIT_MEAL: 'edit-meal/:id',
  CONVERT_MEAL_TO_ADDON: 'convert-meal-to-addon/:id',
  DUPLICATE_MEAL: 'duplicate-meal/:id',
  CONVERT_MEAL_CATEGORY_TO_ADDON_CATEGORY: 'convert-to-addon-category/:id',

  // CREATE SHOP
  SHOP_FORM: 'shop',
  EDIT_SHOP_FORM: 'shop/:shop_id',

  SHOP_DETAILS_PAGE: 'details',
  SHOP_OPENING_TIME: 'opening-time',
  SHOP_DETAILS_METADATA: `metadata`,
  SHOP_FEES: 'fees',

  // CAREERS
  CAREER: '/careers',
  CREATE_POSITION: '/careers/position-form',

  // Create shop
  CREATE_POSITION_FORM_DETAILS: 'details',
  CREATE_POSITION_FORM_DESCRIPTION: 'description',
  CREATE_POSITION_FORM_PREVIEW: 'preview',
  CREATE_POSITION_FORM_APP_SETTINGS: 'application-settings',

  ADDON_CATEGORIES: `meals/:id/addon-categories`,
  ADDON_TITLE: `:title`,
  DUPLICATE_ADDON_CATEGORY: `:addon_id/duplicate-addon-category`,
  UPDATE_ADDON_CATEGORY: `:addon_id/update-addon-category`,
  DUPLICATE_ADDON: `:addon_id/duplicate-addon`,
  ADDON_CATEGORY_ID: `:addon_category_id`,

  KITCHEN_DETAILS: 'details',
  MEALS_BY_CATEGORY: 'meals-by-category',
  MEALS_BY_BASE: 'meals-by-base',

  ITEMS_BY_CATEGORY: 'items-by-category',

  // trash
  TRASH_MEAL: 'meal',
  TRASH_MEAL_CATEGORY: 'meal-category',
  TRASH_ADDON: 'addon',
  TRASH_ADDON_CATEGORY: 'addon-category',
  TRASH_BRAND: 'brand',

  // Feeds
  NEW_FEED: 'new-feed',
  EDIT_FEED: 'edit-feed',

  // Settings
  APP_SETTINGS: 'app',
  PAYMENT_SETTINGS: 'payment',
  OTHER_SETTINGS: 'other',

  // Brand Details
  BRAND_DETAILS_PAGE: 'details',
  BRAND_OPENING_TIME: 'opening-time',
  BRAND_DETAILS_METADATA: `metadata`,
  BRAND_POLYGON: 'polygon',

  CAREER_DETAILS_PAGE: 'details',
  CAREER_DESCRIPTION: 'description',
  CAREER_SETTINGS: 'settings',

  // Create brand
  CREATE_BRAND_DETAILS: 'details',
  CREATE_BRAND_IMAGES: 'images',
  CREATE_BRAND_METADATA: 'metadata',
  CREATE_BRAND_OPENING_TIME: 'opening-time',
  CREATE_BRAND_POLYGON: 'polygon',
  CREATE_BRAND_PREVIEW: 'preview',

  // Create shop
  SHOP_FORM_DETAILS: 'details',
  SHOP_FORM_IMAGES: 'images',
  SHOP_FORM_POLYGON: 'polygon',
  SHOP_FORM_METADATA: 'metadata',
  SHOP_FORM_OPENING_TIME: 'opening-time',
  SHOP_FORM_FEES: 'fees',
  SHOP_FORM_PREVIEW: 'preview',

  // New meal
  NEW_MEAL_BRAND_DETAILS: 'brand-details',
  NEW_MEAL_DETAILS: 'details',
  NEW_MEAL_METADATA: 'metadata',

  // Edit meal
  EDIT_MEAL_BRAND_DETAILS: 'brand-details',
  EDIT_MEAL_DETAILS: 'details',
  EDIT_MEAL_METADATA: 'metadata',

  // New Addon Category
  NEW_ADDON_DETAILS: 'details',
  NEW_ADDON_PREVIEW: 'preview',

  // New meal Via XLS
  NEW_MEAL_XLS_UPLOAD: 'upload-files',
  NEW_MEAL_XLS_REVIEW: 'review',
  NEW_SHOP_MEAL_XLS_REVIEW: 'review-shop-meal',

  // New Cokitchen
  CREATE_COKITCHEN_KITCHEN: 'kitchen',
  CREATE_COKITCHEN_POLYGON: 'polygon',
  CREATE_COKITCHEN_EXPLORE: 'explore',
  CREATE_COKITCHEN_BRANDS: 'brands',
  CREATE_COKITCHEN_FEEDS: 'feeds',
  CREATE_COKITCHEN_PREVIEW: 'preview',

  // New base addon category Via XLS
  BASE_ADDON_CATEGORY_XLS_UPLOAD: 'upload-files',
  BASE_ADDON_CATEGORY_XLS_REVIEW: 'review',

  //Rewards
  LEVELS: '/rewards/levels',
  STREAKS: '/rewards/streaks',
  MAINTENANCE: '/rewards/maintenance',
  CONVERSION_RATE: '/rewards/conversion-rate',
  STREAK_CONTROL: '/rewards/streak-rate',
  PAUSE_CONTROL: '/rewards/pause-control',
  CASHBACK_CONTROL: '/rewards/cashback-control',
  ADD_LEVELS: '/rewards/add-levels',
  EDIT_LEVELS: '/rewards/edit-levels/:id',

  //Giftcards
  GIFTCARD_CATEGORIES: '/giftcards/categories',
  GIFTCARD_CATEGORY_DETAILS: '/giftcards/categories/:id',
  CREATE_GIFTCARD_CATEGORY: '/giftcards/create-category',
  //GIFTCARD_AMOUNT_OPTIONS: '/giftcards/amount-options',
  GIFTCARD_PLAIN_DESIGNS: '/giftcards/plain-designs',
  //Base Items
  BASE_MEAL: 'base-meal',
  BASE_MEAL_UPLOAD: 'upload-base-meal',
  BASE_ADDON: 'base-addon',
  BASE_MEAL_CATEGORY: 'base-meal-category',
  BASE_ADDON_CATEGORY: 'base-addon-category',
  BASE_ADDON_CATEGORY_XLS: 'base-addon-category-xls',
  NEW_BASE_MEAL: 'create-base-meal',
  NEW_BASE_MEAL_CATEGORY: 'create-base-meal-category',
  NEW_BASE_ADDON: 'create-base-addon',
  NEW_BASE_ADDON_CATEGORY: 'create-base-addon-category',
  EDIT_BASE_ADDON_CATEGORY: 'edit-base-addon-category/:id',
  EDIT_BASE_MEAL: 'edit-base-meal/:id',

  //Blog
  BLOGS: '/blogs',
  CREATE_BLOG: '/create-blog',
  CREATE_BLOG_ROUTE_TAG: 'create-blog',
  CREATE_BLOG_BODY: 'create-blog-body',
  CREATE_BLOG_IMAGE: 'create-blog-image',
  CREATE_BLOG_PREVIEW: 'create-blog-preview',

  // Sections
  MANAGE_SECTIONS: '/manage-section',
  MANAGE_SECTIONS_SIDEBAR_PATH: 'manage-section',
  MANAGE_CREATE_SECTION: 'create',
  MANAGE_EDIT_SECTION: ':sectionId/edit',
  // QR Code
  QR_CODE: '/qr-code'
};

export const STORAGE_KEYS = {
  AUTH_TOKEN: 'AUTH_TOKEN',
  USER_ID: 'id',
  EMAIL: 'email',
  FIRST_NAME: 'first_name',
  LAST_NAME: 'last_name',
  ROLE: 'role',
  COKITCHEN: 'cokitchen',
  COKITCHEN_LIST: 'cokitchen_list',
  STAFF_NUMBER: 'staff_number',
  ACTIVE_COKITCHEN: 'active_cokitchen',
  CATEGORY: 'category',
  NEW_ADDON_CATEGORY: 'new_addon_category'
};

export const FILTER_LIST: { name: string; value: ENUM_SEARCH_TYPE }[] = [
  { name: 'Meal', value: ENUM_SEARCH_TYPE.MEAL },
  {
    name: 'Meal category',
    value: ENUM_SEARCH_TYPE.MEAL_CATEGORY
  },
  { name: 'Brand', value: ENUM_SEARCH_TYPE.BRAND },
  {
    name: 'Addon',
    value: ENUM_SEARCH_TYPE.ADDON
  },
  {
    name: 'Addon category',
    value: ENUM_SEARCH_TYPE.ADDON_CATEGORY
  }
];

export const FOOD_CREATE_LIST = [
  {
    name: 'New Cokitchen',
    link: ROUTE_KEYS.CREATE_COKITCHEN
  },
  {
    name: 'New brand',
    emoji: '✨',
    link: ROUTE_KEYS.CREATE_BRAND
  },
  {
    name: 'Add meals via xls',
    emoji: '🚀',
    link: ROUTE_KEYS.NEW_MEAL_XLS
  },
  {
    name: 'New meal',
    emoji: '🍔',
    link: ROUTE_KEYS.NEW_MEAL
  },
  {
    name: 'New meal category',
    emoji: '🍇',
    link: ROUTE_KEYS.NEW_MEAL_CATEGORY
  },
  {
    name: 'New add-on',
    emoji: '🍕',
    link: ROUTE_KEYS.NEW_ADDON
  },
  {
    name: 'New addon category',
    emoji: '🍕',
    link: ROUTE_KEYS.NEW_ADDON_CATEGORY
  }
];
export const SHOP_CREATE_LIST = [
  {
    name: 'New Cokitchen',
    link: ROUTE_KEYS.CREATE_COKITCHEN
  },
  {
    name: 'New shop',
    emoji: '✨',
    link: ROUTE_KEYS.SHOP_FORM
  },
  {
    name: 'Add items via xls',
    emoji: '🚀',
    link: ROUTE_KEYS.NEW_MEAL_XLS
  }
];
export const days = () => {
  const openingTime = new Date();
  openingTime.setHours(10);
  openingTime.setMinutes(0);
  openingTime.setSeconds(0);
  const closingTime = new Date();
  closingTime.setHours(0.0);
  closingTime.setMinutes(0);
  closingTime.setSeconds(0);

  return [
    { name: 'Monday', opening_time: openingTime, closing_time: closingTime, active: true },
    { name: 'Tuesday', opening_time: openingTime, closing_time: closingTime, active: true },
    { name: 'Wednesday', opening_time: openingTime, closing_time: closingTime, active: true },
    { name: 'Thursday', opening_time: openingTime, closing_time: closingTime, active: true },
    { name: 'Friday', opening_time: openingTime, closing_time: closingTime, active: true },
    { name: 'Saturday', opening_time: openingTime, closing_time: closingTime, active: true },
    { name: 'Sunday', opening_time: openingTime, closing_time: closingTime, active: true }
  ];
};

export const POLYGON_COLORS = [
  {
    color_code: '#9b5de5'
  },
  {
    color_code: '#264653'
  },
  {
    color_code: '#d90429'
  },
  {
    color_code: '#fee440'
  },
  {
    color_code: '#f15bb5'
  },
  {
    color_code: '#bc4749'
  },
  {
    color_code: '#80e47c'
  },
  {
    color_code: '#3c096c'
  },
  {
    color_code: '#0496ff'
  },
  {
    color_code: '#eb5e28'
  },
  {
    color_code: '#718355'
  },
  {
    color_code: '#f1c0e8'
  },
  {
    color_code: '#8e7dbe'
  },
  {
    color_code: '#661d44'
  },
  {
    color_code: '#5d5f76'
  },
  {
    color_code: '#23c881'
  },
  {
    color_code: '#63e448'
  },
  {
    color_code: '#3371fb'
  },
  {
    color_code: '#21a5c8'
  },
  {
    color_code: '#aa80fd'
  },
  {
    color_code: '#87ca80'
  },
  {
    color_code: '#4167cf'
  }
];
export const rewardTypes: MultiselectItem[] = [
  { text: 'Voucher', value: 'Voucher' },
  { text: 'Discount', value: 'Discount' },

  { text: 'Free delivery', value: 'Free Delivery' }
];

export const selectionTypeList: MultiselectOptionsType[] = [
  {
    value: '04822c95-519d-42d0-bd92-3c5923839670',
    text: 'Radio'
  },
  {
    value: '35fbe06c-c6f8-4ca4-80d8-8a07020e5902',
    text: 'Checkbox'
  },
  {
    value: 'ac7fc7d6-619b-4176-a0e8-10e7f2c6f5f4',
    text: 'Multiple'
  }
];
export const SOLD_OUT_MINUTES = [10, 20, 30, 40, 50, 60];

export const getOpeningTime = (workHours: Array<{ day: string; opening_time: string }>): string => {
  const dayAfterToday = moment().add(1, 'days').format('YYYY-MM-DD');
  const tomorrowDay = moment(dayAfterToday).format('dddd');
  // get opening time for tomorrow
  const tomorrowDayWorkingHours = workHours?.filter((itm: { day: string }) => {
    return itm?.day?.includes(tomorrowDay.toLocaleLowerCase());
  });
  const opening_time = tomorrowDayWorkingHours[0]?.opening_time;
  const tomorrow = moment().add(1, 'days').format('YYYY-MM-DD');
  const tomorrowDate = moment(tomorrow).format();
  // get the hour before openingTime
  const openingTime = moment(opening_time, 'HH:mm:ss').subtract(1, 'hours').format('HH:mm:ss');
  const openingTimeTomorrow = tomorrowDate.replace('00:00:00', openingTime);
  return openingTimeTomorrow;
};

export const FCB_BRAND_TYPE_OPTIONS: MultiselectItem[] = [
  { value: ENUM_BRAND_TYPE.FCB_CUSTOM_BREAKFAST, text: 'FCB Breakfast' },
  { value: ENUM_BRAND_TYPE.FCB_CUSTOM_LUNCH, text: 'FCB Lunch' },
  { value: ENUM_BRAND_TYPE.FCB_CUSTOM_AFTERHOURS, text: 'FCB Afterhours' }
];
export const PROVIDER_BRAND_TYPE_OPTIONS: MultiselectItem[] = [
  { value: ENUM_BRAND_TYPE.FOODCOURT, text: 'FoodCourt' },
  { value: ENUM_BRAND_TYPE.CHOWDECK, text: 'Chowdeck' },
  { value: ENUM_BRAND_TYPE.GLOVO, text: 'Glovo' }
];

export const FC_BRAND_TYPE_OPTIONS: MultiselectItem[] = [
  { value: ENUM_BRAND_TYPE.FOODCOURT, text: 'Foodcourt' },
  { value: ENUM_BRAND_TYPE.BUDGET, text: 'Budget' },
  { value: ENUM_BRAND_TYPE.PIZZA, text: 'Pizza' }
];
export const ALL_BRAND_TYPE_OPTIONS: MultiselectItem[] = [
  ...FC_BRAND_TYPE_OPTIONS,
  ...PROVIDER_BRAND_TYPE_OPTIONS,
  { value: ENUM_BRAND_TYPE.FOODCOURT_BUSINESS, text: 'FoodCourt Business' },
  ...FCB_BRAND_TYPE_OPTIONS
];

export const FC_POINTS_THRESHOLDS = {
  [ENUM_TIER_NAME.FOODIE]: 100000,
  [ENUM_TIER_NAME.TASTER]: 200000,
  [ENUM_TIER_NAME.GOURMET]: 300000,
  [ENUM_TIER_NAME.FEAST_MASTER]: 400000,
  [ENUM_TIER_NAME.BON_VIVANT]: 500000
};

export const initRolePermissions: RolePermissionType = {
  isAdminRole: false,
  isDeveloperRole: false,
  isHRRole: false,
  isMarketingRole: false,
  isShopRole: false,
  isSuperAdminRole: false,
  canViewBlog: false,
  canViewCareers: false,
  canSearch: false,
  canAccessCreateList: false,
  canViewProfileDropDown: false,
  canAccessBaseItems: false,
  canAccessCareers: false,
  canAccessBlog: false,
  canAccessFeeds: false,
  canAccessGiftCards: false,
  canAccessKitchenDetails: false,
  canAccessMeals: false,
  canAccessMetadata: false,
  canAccessOverview: false,
  canAccessPolygons: false,
  canAccessRewards: false,
  canAccessSettings: false,
  canAccessTrash: false
};
